(function () {
  'use strict';

  const STORAGE_KEY = 'pn_wishlist';

  function read() {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (_) {
      return [];
    }
  }

  function write(arr) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
  }

  function toggle(handle) {
    const list = read();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    write(list);
    return idx === -1;
  }

  function syncButtons() {
    const list = read();
    document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      const active = list.includes(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateBadge() {
    const count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.dataset.productHandle);
      syncButtons();
      updateBadge();
      if (document.getElementById('wishlist-grid')) renderWishlistPage();
      return;
    }

    const card = e.target.closest('#wishlist-grid product-card[data-product-handle]');
    if (card && !e.target.closest('a, button')) {
      window.location.href = '/products/' + card.dataset.productHandle;
    }
  });

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[c]));
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(cents / 100);
    } catch (_) {
      return '€' + (cents / 100).toFixed(2);
    }
  }

  const heartIconSVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function renderCard(p) {
    const img = p.featured_image
      ? '<img src="' + p.featured_image + '" alt="' + escapeHtml(p.title) + '" class="product-card__image product-card__image--fill" loading="lazy">'
      : '';
    const title = escapeHtml(p.title);
    return (
      '<product-card class="product-card" data-product-id="' + p.id + '" data-product-handle="' + escapeHtml(p.handle) + '">' +
        '<a href="/products/' + escapeHtml(p.handle) + '" class="product-card__link" aria-label="' + title + '">' +
          '<span class="visually-hidden">' + title + '</span>' +
        '</a>' +
        '<div class="product-card__media">' +
          '<button type="button" class="product-card__wishlist is-active" data-wishlist-btn data-product-handle="' + escapeHtml(p.handle) + '" aria-label="Remove from wishlist" aria-pressed="true">' +
            heartIconSVG +
          '</button>' +
          img +
        '</div>' +
        '<h3 class="product-card__title">' + title.toUpperCase() + '</h3>' +
        '<span class="product-card__price">' + formatMoney(p.price) + '</span>' +
      '</product-card>'
    );
  }

  async function renderWishlistPage() {
    const grid = document.getElementById('wishlist-grid');
    const empty = document.getElementById('wishlist-empty');
    if (!grid) return;

    const handles = read();
    if (handles.length === 0) {
      grid.hidden = true;
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    const results = await Promise.allSettled(
      handles.map((h) =>
        fetch('/products/' + encodeURIComponent(h) + '.js').then((r) =>
          r.ok ? r.json() : Promise.reject()
        )
      )
    );
    const products = results
      .filter((r) => r.status === 'fulfilled')
      .map((r) => r.value);

    const validHandles = products.map((p) => p.handle);
    if (validHandles.length !== handles.length) write(validHandles);

    if (products.length === 0) {
      grid.hidden = true;
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = products.map(renderCard).join('');
    syncButtons();
    updateBadge();
  }

  function init() {
    syncButtons();
    updateBadge();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) {
      syncButtons();
      updateBadge();
      if (document.getElementById('wishlist-grid')) renderWishlistPage();
    }
  });
})();
